const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '采购概况',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '公告信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '标段/标包信息',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '包件',
            data: [],
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '采购单位信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    // 后端说暂时没有返回这部分数据
    // {
    //     component: 'ZlmTitle',
    //     options: {
    //         size: 'medium',
    //         text: '审核记录',
    //     },
    // },
    // {
    //     component: 'ZlmTabDetail',
    //     options: {
    //         title: '记录',
    //         data: [],
    //     },
    // },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.getGGBdList(res.data.ggGuid)
                this.config[1].options.data = {
                    '项目名称': res.data.gcName,
                    '项目编号': res.data.gcBH,
                    '项目类型': getProjectTypeName(res.data.xmLeiXing),
                    '采购方式': getPurchaseTypeName(res.data.zhaoBiaoFangShi),
                    // '行业分类': res.data.hangYeFenLei,
                    // '报价方式': '', //api没有
                    // '项目概况': '', //api没有
                    // '基本要求': '', //api没有
                }
                this.config[3].options.data = {
                    '公告名称': res.data.ggName,
                    // '公告发布媒体': '', //api没有
                    '公告开始时间': this.$util.timeFormatter(res.data.ggStartTime),
                    // '公告附件': '', //api没有
                }
                // 获取采购单位信息
            this.getGGBdInfo()
            })
        },
        getGGBdList(guid) {
            this.$request.post(`/transformToAfter/app/track/announce/queryggBdList`, {
                ggGuid: guid,
            }).then((res) => {
                if (res.data && res.data.list) {
                    console.log('-------')
                    console.log(res)
                    console.log('-------')
                    this.config[5].options.data = res.data.list.map((t) => ({
                            '包件名称': t.bdName,
                            '包件编号': t.bdBH,
                            '文件获取开始时间': this.$util.timeFormatter(t.zbWJHuoQuStartTime),
                            '文件获取截止时间': this.$util.timeFormatter(t.zbWJHuoQuEndTime),
                            '澄清截止时间': this.$util.timeFormatter(t.zbWJDaYiEndTime),
                            '截标/开标时间': this.$util.timeFormatter(t.kbTime),
                            '标书获取地点': t.tbWJDiJiaoDiDian,
                            '开标地点': t.kbDiDian,
                            '采购范围': t.zbFanWei,
                            '资格条件': t.ziZhiYaoQiu,
                        }))
                }
            })
        },
        getGGBdInfo() {
            this.$request.post(`/transformToAfter/app/track/announce/zbGc`, {
                bdGuid: this.$route.query.id,
            }).then((res) => {
                if (res.data) {
                    this.config[1].options.data['项目编号'] = res.data.gcBH
                    this.config[7].options.data = {
                        '采购单位名称': res.data.zbRName,
                        '采购单位地址': res.data.zbrAddress,
                        '联系人': res.data.lianXiRenName,
                        '联系电话': res.data.lianXiRenPhone,
                    }
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
